import { isUnifiedPositionEnabled } from "app/components/campaigns/shared/utils/isUnifiedPositionEnabled";

export const WEIGHTED_AVG_POSITION_TOOLTIP_I18N = {
    tags: {
        legacy: "keywordsCampaign.tags.positionColumn.tooltip",
        unified: "keywordsCampaign.tags.positionColumn.tooltip.unified",
    },
    pages: {
        legacy: "seo.rankTracker.pagesReport.table.tab.firstLastCell.tooltip",
        unified: "seo.rankTracker.pagesReport.table.tab.position.tooltip.unified",
    },
    competitors: {
        legacy: "seo.rankTracker.competitorsReport.table.column.positions.firstLastCell.tooltip",
        unified: "seo.rankTracker.competitorsReport.table.column.positions.firstLastCell.tooltip.unified",
    },
} as const;

export type WeightedAvgPositionTooltipReport = keyof typeof WEIGHTED_AVG_POSITION_TOOLTIP_I18N;

export const getWeightedAvgPositionTooltipKey = (report: WeightedAvgPositionTooltipReport): string => {
    const keys = WEIGHTED_AVG_POSITION_TOOLTIP_I18N[report];
    return isUnifiedPositionEnabled() ? keys.unified : keys.legacy;
};
